<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'
export default {
    init: async payload => {
        payload.initTable()

        payload.isSuperAdminMaster = await Common.isSuperAdminMaster(payload)
        payload.accounts = await Services.getAccounts(payload)
        const account = await Common.getAccountId(payload)

        payload.filters.account = account

        if (account) {
            payload.clients = await Services.getClients(payload)
        }

        if (!payload.isSuperAdminMaster) {
            payload.columns.splice(2, 1)
        }
    },
    methods: {
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            this.isLoading = true
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.siteGroups.filter}`,
                response => {
                    this.applyServerPage(response)
                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        async selectItem(params) {
            const data =
                params && params?.row
                    ? JSON.parse(JSON.stringify(params.row))
                    : {
                          ...this.siteGroupObj,
                      }

            delete data.vgt_id
            delete data.originalIndex

            if (!data.account && !this.isSuperAdminMaster) {
                data.account = await Common.getAccountId(this)
            } else {
                data.account = data.account._id
            }

            if (data.client) {
                data.client = data.client._id
            }

            this.data = data

            this.$bvModal.show('createSiteGroupModal')
        },
        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.site.groups.column.name'),
                    field: 'name',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.groups.column.assigned.sites'),
                    field: 'sites',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.groups.column.account'),
                    field: 'account.name',
                    width: '20%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.groups.column.creat.at'),
                    field: 'createDate',
                    width: '20%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.groups.column.status'),
                    field: 'status',
                    width: '20%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: false,
                    filterable: false,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        changeAccount: async function () {
            const account = this.filters.account

            this.sites = []
            this.filters.client = ''

            this.filterFromFirstPage()

            this.clients = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.filters.client

            this.filterFromFirstPage()

            this.sites = await Services.getSitesByClient(this, client)
        },
        changeSite: function () {
            this.filterFromFirstPage()
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
